import './App.css';

import { Component } from 'react';
import EditorField from './widgets/EditorField';
import ToolPalette from './widgets/ToolPalette';
import BProject, { simple_rect_coordinates } from './model/BProject';
import { disposeAllMapFeatures, renewEditorFeatures, updateMapFeatureLatLngs } from './MapViewController';
import { GridBackgroundLayer } from './MapBackground';
import StekView from './StekView';
import SkRenderingContext from './stek/sk-rendering';
import StekViewController from './StekViewController';
import BFloor, { kPresetFloorColorList } from './model/BFloor';
import { B_AttrFlags, BEV_FLOOR_ADDED, BEV_REQUEST_EXECUTE, BEV_REQUEST_UPDATE_UNDO, BEV_SHAPE_MAJOR_CHANGE, serialize_mat4 } from './model/BBase';
import BCommandStack from './commands/command-stack';
import { BAddItemCommand } from './commands/commands';
import BPolyline from './model/BPolyline';
import qmath from './stek/qmath';
import addToolBarHandlers from './app-toolbar';
import AuthInfo from './widgets/AuthInfo';

// Cognito integration >>>
import { AuthProvider } from "react-oidc-context";
const cognitoAuthConfig = {
	authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_RLjB2GlUL",
	client_id: "2qfnalce94gme9j757d3tvhur9",
	redirect_uri: "https://stek.pornanime.club/",
	response_type: "code",
	scope: "email openid phone",
};


class App extends addToolBarHandlers(Component) {
	constructor(props) {
		super(props);
		this.lmap = null;

		const newproj = new BProject();
		newproj.setupTemplate();
		newproj.addEventListener( this.onProjectEvent.bind(this) );

		const sctx = new SkRenderingContext();
		this.viewController = new StekViewController(sctx, this);


		this.state = {
			project: newproj,
			commandStack: new BCommandStack(),
			stekContext: sctx,
			svForceRender: 0,
			editingFloor: null,
			canUndo: false,
			canRedo: false
		};

		window.onresize = this.onWindowResize.bind(this);
	}

	getCurrentProject() {
		return this.state.project;
	}

	render() {
		const pj = this.getCurrentProject();

		return <div><EditorField
			onMapCreated={ this.onEditorMapCreated.bind(this) }
			willMapRemove={ this.willMapRemove.bind(this) }
			activeBuilding={ pj.activeBuilding }
			editingFloor={ this.state.editingFloor } />
			<ToolPalette 
				onAddFloorClick={ this.onToolAddFloorClick.bind(this) }
				onRemoveFloorClick={ this.onToolRemoveFloorClick.bind(this) }
				onFloorClick={ this.onFloorSelectorFloorClick.bind(this) }
				onAddPolygonClick={ this.onToolAddPolygonClick.bind(this) }
				onAddNodeClick={ this.onToolAddNodeClick.bind(this) }
				onAddElevatorClick={ this.onToolAddElevatorClick.bind(this) }
				onAddStairsClick={ this.onToolAddStairsClick.bind(this) }
				onUndoClick={ this.onToolUndoClick.bind(this) }
				onRedoClick={ this.onToolRedoClick.bind(this) }
				onSaveClick={ this.onToolSaveClick.bind(this) }
				onLoadClick={ this.onToolLoadClick.bind(this) }
				activeBuildingIndex={ pj.activeBuildingIndex }
				activeBuilding={ pj.activeBuilding }
				buildingNames={ pj.buildingNameList }
				editingFloor={ this.state.editingFloor }
				canUndo={ this.state.canUndo }
				canRedo={ this.state.canRedo } />
			<StekView 
			viewController={ this.viewController }
			stekContext={ this.state.stekContext }
			project={ pj }
			pixelRatio={ 1 }
			svForceRender={ this.state.svForceRender } />
			<AuthProvider {...cognitoAuthConfig}><AuthInfo /></AuthProvider>
		</div>;
	}

	onProjectEvent(sender, eventType, param) {
		if (eventType === BEV_REQUEST_EXECUTE) {
			this.executeCommand(param);
		} else if (eventType === BEV_REQUEST_UPDATE_UNDO) {
			this.state.commandStack.invalidateRedo().push(param);
			this.updateUndoState();
		} else if (eventType === BEV_FLOOR_ADDED) {
			this.setState({editingFloor: param});
		} else if (eventType === BEV_SHAPE_MAJOR_CHANGE) {
			renewEditorFeatures(sender);
			updateMapFeatureLatLngs(sender);
		} else {
			this.svOnChange();
		}
	}

	executeCommand(cmd) {
		cmd.execute(this);
		this.state.commandStack.invalidateRedo().push(cmd);

		this.updateUndoState();
	}

	updateUndoState() {
		this.setState({
			canUndo: this.state.commandStack.canUndo(),
			canRedo: this.state.commandStack.canRedo()
		});
	}

	onEditorMapCreated(m) {
		if (m?._sk_configured) { return; }
		m._sk_configured = true;

		this.lmap = m;
		configureBasemap(m);

		const pj = this.getCurrentProject();
		const efloor = pj.activeBuilding?.getLastFloor() ?? null;
		this.setState({editingFloor: efloor});
	}

	willMapRemove(m) {
		if (m?._sk_configured) {
			m._sk_configured = false;

			if (this.lmap) {
				disposeAllMapFeatures(this.getCurrentProject());
				this.lmap = null;
			}
		}
	}

	svOnChange() {
		this.setState({svForceRender: 1 - this.state.svForceRender});
	}

	onWindowResize() {
		this.svOnChange();
	}

	onToolAddFloorClick() {
		const pj = this.getCurrentProject();
		const bld = pj.activeBuilding;
		if (bld) {
			const lastFloor = bld.getLastFloor();
			const suggestedTitle = suggestNextFloorTitle(lastFloor ? lastFloor.title : null);
			const colorIndex = bld.generateNextFloorColorIndex();
			const newAlt = lastFloor.floorAltitude + pj.defaultAltStep;

			/*
			bld.addItem(newFloor);
*/
			const initial_trans = new qmath.Mat4();
			BFloor.setFloorAltTransform(initial_trans, newAlt);

			// Prepare new floor options
			const f_ser = BAddItemCommand.generateSerializedDataTemplate(bld, BFloor, {
				floorAltitude: newAlt,
				itemTransform: serialize_mat4(initial_trans),
				editorColor: kPresetFloorColorList[colorIndex],
				title: suggestedTitle,
				_afterRemove: {
					editingFloor: this.state.editingFloor
				}
			});

			const p_ser = BAddItemCommand.generateSerializedDataTemplate(f_ser, BPolyline, {
				coordinates: [simple_rect_coordinates(50)],
				flags: B_AttrFlags.BuildingOuter
			});
			f_ser.children = [p_ser];

			const cmd = new BAddItemCommand(f_ser);
			this.executeCommand(cmd);
		}
	}

	selectFloorById(floorObjId) {
		const pj = this.getCurrentProject();
		const found = pj.findById(floorObjId);

		if (found) {
			const bldg = found.getOwnerBuilding();
			if (bldg) {
				this.setState({editingFloor: found});
			}
		}
	}
}

function configureBasemap(lmap) {
/*
	const OriginIcon = L.icon({
		iconUrl: "/images/origin-marker-m.png",
		iconSize: [16, 16],
		iconAnchor: [5, 5]
	});

	const mk = L.marker([0, 0], {
		icon: OriginIcon,
		interactive: false
	}).addTo(lmap);
*/
	const g = new GridBackgroundLayer({minZoom: -5});
	g.addTo(lmap);
}

function suggestNextFloorTitle(prevTitle) {
	let oldFNum = -1;
	let prefix = "";
	let suffix = "F";

	if (prevTitle && prevTitle.match) {
		const m = prevTitle.match( /(b)?(\d+)(.+)?/i );
		oldFNum = parseInt(m[2], 10);

		if (m[1]) {
			prefix = m[1];
			oldFNum *= -1;
		}

		if (m[3]) {
			suffix = m[3];
		}
	} else {

	}

	let newFNum = oldFNum + 1;
	if (newFNum === 0) { ++newFNum };

	if (newFNum < 0) {
		// basement
		return `${prefix}${-newFNum}${suffix}`;
	} else {
		return `${newFNum}${suffix}`;
	}
}

export default App;
